/**
 * @generated SignedSource<<4d26d8d3096d10fdfb178d537b3d5e69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type InspectionDetailsPageQuery$variables = {
  id: string;
};
export type InspectionDetailsPageQuery$data = {
  readonly inspectionfield: {
    readonly externalId: number | null;
    readonly id: string;
    readonly plannedDate: any | null;
    readonly state: InspectionfieldStateEnum | null;
    readonly year: number;
    readonly " $fragmentSpreads": FragmentRefs<"InspectionDetailsContainer" | "InspectionFieldMap" | "InspectionFormOverview" | "InspectionHeader" | "InspectionReportOverview">;
  } | null;
};
export type InspectionDetailsPageQuery = {
  response: InspectionDetailsPageQuery$data;
  variables: InspectionDetailsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plannedDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberNode",
  "kind": "LinkedField",
  "name": "member",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AddressNodeConnection",
      "kind": "LinkedField",
      "name": "address",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AddressNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AddressNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "street",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "houseNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "zipcode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "city",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  (v2/*: any*/)
],
v10 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "approvedDate",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rejectedDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retryDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayNameAlt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionDetailsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InspectionfieldNode",
        "kind": "LinkedField",
        "name": "inspectionfield",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InspectionHeader"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InspectionFieldMap"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InspectionFormOverview"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InspectionReportOverview"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InspectionDetailsContainer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InspectionDetailsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "InspectionfieldNode",
        "kind": "LinkedField",
        "name": "inspectionfield",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "FieldNode",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previousId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "geometry",
                "storageKey": null
              },
              (v4/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectNode",
            "kind": "LinkedField",
            "name": "managementPackageVariant",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ManagementPackageNode",
                "kind": "LinkedField",
                "name": "managementPackage",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionNode",
            "kind": "LinkedField",
            "name": "latestInspection",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastModified",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionFormNode",
                "kind": "LinkedField",
                "name": "inspectionform",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionFormNodeConnection",
            "kind": "LinkedField",
            "name": "inspectionforms",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionFormNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionFormNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionNodeConnection",
            "kind": "LinkedField",
            "name": "inspections",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InspectorNode",
                        "kind": "LinkedField",
                        "name": "inspector",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InspectionfieldNode",
                        "kind": "LinkedField",
                        "name": "inspectionfield",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CollectiveNode",
                            "kind": "LinkedField",
                            "name": "collective",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ManagementPackageSettingsNode",
                            "kind": "LinkedField",
                            "name": "managementPackageSetting",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InspectionReportNode",
                        "kind": "LinkedField",
                        "name": "report",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorageObjectNode",
                            "kind": "LinkedField",
                            "name": "pdf",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "downloadUrl",
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "retry",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pdfName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "periodEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notes",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ManagementPackageSettingsNode",
            "kind": "LinkedField",
            "name": "managementPackageSetting",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pdfFileUrl",
                "storageKey": null
              },
              (v16/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dca117de4ffb72c988393645897a8f12",
    "id": null,
    "metadata": {},
    "name": "InspectionDetailsPageQuery",
    "operationKind": "query",
    "text": "query InspectionDetailsPageQuery(\n  $id: ID!\n) {\n  inspectionfield(id: $id) {\n    id\n    externalId\n    year\n    state\n    plannedDate\n    ...InspectionHeader\n    ...InspectionFieldMap\n    ...InspectionFormOverview\n    ...InspectionReportOverview\n    ...InspectionDetailsContainer\n  }\n}\n\nfragment FieldMap on FieldNode {\n  geometry\n}\n\nfragment InspectionDetailsContainer on InspectionfieldNode {\n  year\n  name\n  state\n  plannedDate\n  periodStart\n  periodEnd\n  assignedDate\n  reason\n  notes\n  latestInspection {\n    approvedDate\n    rejectedDate\n    lastModified\n    retryDate\n    id\n  }\n  member {\n    name\n    phone\n    email\n    address {\n      edges {\n        node {\n          id\n          street\n          houseNumber\n          zipcode\n          city\n        }\n      }\n    }\n    id\n  }\n  managementPackageSetting {\n    pdfFileUrl\n    displayNameAlt\n    id\n  }\n  field {\n    id\n    year\n    previousId\n    member {\n      name\n      phone\n      email\n      address {\n        edges {\n          node {\n            id\n            street\n            houseNumber\n            zipcode\n            city\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment InspectionFieldMap on InspectionfieldNode {\n  field {\n    ...FieldMap\n    geometry\n    id\n  }\n}\n\nfragment InspectionFormOverview on InspectionfieldNode {\n  id\n  externalId\n  year\n  state\n  plannedDate\n  assignedDate\n  managementPackageVariant {\n    code\n    name\n    managementPackage {\n      name\n      id\n    }\n    id\n  }\n  latestInspection {\n    id\n    state\n    lastModified\n    inspectionform {\n      id\n      year\n    }\n  }\n  inspectionforms {\n    edges {\n      node {\n        id\n        year\n      }\n    }\n  }\n  field {\n    year\n    id\n  }\n}\n\nfragment InspectionHeader on InspectionfieldNode {\n  externalId\n  field {\n    id\n    previousId\n  }\n}\n\nfragment InspectionReportCard on InspectionNode {\n  id\n  inspector {\n    firstName\n    lastName\n    user {\n      firstName\n      lastName\n      id\n    }\n    id\n  }\n  inspectionfield {\n    collective {\n      name\n      id\n    }\n    year\n    managementPackageSetting {\n      displayNameAlt\n      id\n    }\n    id\n  }\n  report {\n    id\n    pdf {\n      downloadUrl\n      id\n    }\n  }\n  state\n  approvedDate\n  rejectedDate\n  retryDate\n  retry\n  pdfName\n}\n\nfragment InspectionReportOverview on InspectionfieldNode {\n  inspections {\n    edges {\n      node {\n        id\n        approvedDate\n        rejectedDate\n        retryDate\n        ...InspectionReportCard\n        state\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8d032c0c93ec3a3427306b19726849a";

export default node;
